<template>
  <div class="vs-row full-height m-0">
    <div class="header-top clearfix">
      <div class="container">
        <div class="row mt-5">
          <div class="col-md-2 col-sm-5 col-12 mobile-center">
            <a href="#">
              <img
                class="img-responsive"
                src="@/assets/images/logo/nowe/logo-color.svg"
                style="max-width: 190px;"
              />
            </a>
          </div>
          <div class="col-md-5"></div>
          <div class="col-md-5 col-sm-7 col-12 text-right mobile-center">
            <a href="tel:+48800706988">
              <img
                class="img-responsive"
                src="@/assets/images/logo/numer.jpg"
                style="max-width: 190px; margin-top: 5px;"
              />
              <span>800 706 988</span>
            </a>
            <vs-button
              class="login-button"
              color="#e40712"
              type="filled"
              icon="person"
              href="/login"
              style="float: right;"
              >Zaloguj</vs-button
            >
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <img
              class="img-responsive"
              src="@/assets/images/background/dolacz-do-klubu-baner.png"
              style="max-width: 100%;cursor: pointer;"
              @click="$router.push('/login')"
            />
          </div>
        </div>
        <div class="row text-center mt-5">
          <div class="col">
            <h2>Poznaj korzyści<br /><b>Dla klubowiczów</b></h2>
          </div>
        </div>
        <div class="row text-center mt-2">
          <div class="col-md-4 col-sm-6 col-12 mt-5">
            <img
              class="img-responsive mb-2"
              src="@/assets/images/logo/nowe/prezenty.svg"
              style="max-width: 65px;"
            />
            <p>
              <b>Prezenty</b><br />Wybierz jeden<br />
              z 3 upominków za 1zł
            </p>
          </div>
          <div class="col-md-4 col-sm-6 col-12 mt-5">
            <img
              class="img-responsive mb-2"
              src="@/assets/images/logo/nowe/rabaty.svg"
              style="max-width: 65px;"
            />
            <p><b>Rabaty</b><br />3 bony po 20zł<br />na dowolne zakupy</p>
          </div>
          <div class="col-md-4 col-sm-6 col-12 mt-5">
            <img
              class="img-responsive mb-2"
              src="@/assets/images/logo/nowe/100-lat.svg"
              style="max-width: 65px;"
            />
            <p>
              <b>100 lat!</b><br />Specjalna oferta<br />z okazji Twoich urodzin
            </p>
          </div>
          <div class="col-md-4 col-sm-6 col-12 mt-5">
            <img
              class="img-responsive mb-2"
              src="@/assets/images/logo/nowe/100-dni.svg"
              style="max-width: 65px;"
            />
            <p>
              <b>100 dni</b><br />Na zwrot w ramach<br />odstąpienia od umowy
            </p>
          </div>
          <div class="col-md-4 col-sm-6 col-12 mt-5">
            <img
              class="img-responsive mb-2"
              src="@/assets/images/logo/nowe/wysylka.svg"
              style="max-width: 65px;"
            />
            <p>
              <b>Wysyłka gratis</b><br />Bezpłatna dostawa<br />powyżej 199,90
              zł
            </p>
          </div>
          <div class="col-md-4 col-sm-6 col-12 mt-5">
            <img
              class="img-responsive mb-2"
              src="@/assets/images/logo/nowe/punkty.svg"
              style="max-width: 65px;"
            />
            <p>
              <b>Zbieraj punkty...</b><br />...i wymieniaj je<br />na atrakcyjne
              nagordy
            </p>
          </div>
        </div>
        <!-- <div class="row text-center mt-5">
                    <div class="col-md-2"></div>
                    <div class="col-md-8">
                        <p class="heading">Za każde wydane <b style="color: #FA7B35">10zł</b> otrzymasz <b style="color: #FA7B35">1 punkt</b>,<br>który potem będziesz mógł wymienić na nagrody.</p>
                    </div>
                    <div class="col-md-2"></div>
                </div> -->
        <div class="row full-width" style>
          <div class="col-md-12 text-center">
            <img
              src="@/assets/images/background/jak-dolaczyc-baner.png"
              style="max-width: 62.3%; margin-left: -64px;cursor: pointer;"
              @click="$router.push('/login')"
            />
          </div>
        </div>
        <div class="row text-center mt-2">
          <div class="col-12 mt-5">
            <img
              src="@/assets/images/background/punkty-baner.png"
              style="max-width: 100%;"
              
            />
          </div>
          <!-- <div class="col-md-3 col-sm-6 col-12 mt-5">
            <img
              class="img-responsive mb-2"
              src="@/assets/images/logo/Punkty1.jpg"
              style="max-width: 100%;"
            />
          </div>
          <div class="col-md-3 col-sm-6 col-12 mt-5">
            <div class="row">
              <img
                class="img-responsive mb-2"
                src="@/assets/images/logo/Punkty2.jpg"
                style="max-width: 40%; margin-top: 40px;"
              />
              <p style="margin-top: 70px;">
                <b>Darmowa<br />dostawa</b>
              </p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-12 mt-5">
            <div class="row">
              <img
                class="img-responsive mb-2"
                src="@/assets/images/logo/Punkty3.jpg"
                style="max-width: 40%; margin-top: 40px;"
              />
              <p style="margin-top: 70px;">
                <b>20 złotych<br />rabatu</b>
              </p>
            </div>
          </div>
          <div class="col-md-3 col-sm-6 col-12 mt-5">
            <div class="row">
              <img
                class="img-responsive mb-2"
                src="@/assets/images/logo/Punkty4.jpg"
                style="max-width: 40%; margin-top: 40px;"
              />
              <p style="margin-top: 70px;">
                <b>Prezent<br />za 1 zł</b>
              </p>
            </div>
          </div> -->
        </div>
        <div class="row text-center mt-5">
          <div class="col-md-2"></div>
          <div class="col-md-8">
            <p class="heading"><b>Z kartą stać Cię na wszystko</b></p>
          </div>
          <div class="col-md-2"></div>
        </div>
        <!-- <div class="row">
                    <NavigationCarousel></NavigationCarousel>
                </div> -->
        <FooterDrop></FooterDrop>
        <div class="row full-width-footer mt-5">
          <div class="col-md-3 col-12 text-right mb-5">
            <a href="#">
              <img
                class="img-responsive"
                src="@/assets/images/logo/nowe/logo-color.svg"
                style="max-width: 190px;"
              />
            </a>
          </div>
          <div class="col-md-3 col-12 text-center mb-5">
            <p class="heading-footer">BĄDŹ NA BIEŻĄCO</p>
            <a href="https://www.facebook.com/tvokazje"
              ><img
                class="img-responsive"
                src="@/assets/images/logo/facebook.png"
                style="max-width: 43px; margin-right: 15px;"
            /></a>
            <a
              href="https://www.youtube.com/channel/UCE5SDkPdH6YcISOPFDXs4-A/featured"
              ><img
                class="img-responsive"
                src="@/assets/images/logo/youtube.png"
                style="max-width: 60px; margin-right: 15px;"
            /></a>
            <a href="https://www.instagram.com/tvokazje.pl/"
              ><img
                class="img-responsive"
                src="@/assets/images/logo/instagram.png"
                style="max-width: 43px; margin-right: 15px;"
            /></a>
          </div>
          <div class="col-md-6 col-12 mb-5">
            <p class="heading-footer">CERTYFIKATY</p>
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/payu.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/mastercard.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/opineo.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/comodo-secure.png"
              style="max-width: 60px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/era.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/fedex.png"
              style="max-width: 120px; margin-right: 2px;"
            />
            <img
              class="img-responsive"
              src="@/assets/images/logo/nowe/rzetelnafirma.png"
              style="max-width: 110px; margin-right: 2px;"
            />
          </div>
          <hr />
        </div>
        <div class="row full-width-footer-bottom mt-5 text-center">
          <div class="col-12">
            <p class="mt-4">
              &copy; 2020 TVO Sp. z o.o. wszelkie prawa zastrzeżone
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import NavigationCarousel from "../extra-components/carousel/NavigationCarousel";
// import Footer from "../extra-components/Footer";
import FooterDrop from "../extra-components/FooterDrop";

export default {
  name: "Carousel",
  data: () => ({
    title: "Carousel"
  }),
  components: {
    // NavigationCarousel,
    // Footer,
    FooterDrop
  }
};
</script>
<style lang="scss" scoped>
p {
  font-size: 20px;
}
p.heading {
  font-size: 24px;
}
.col-md-5.col-sm-7.col-12.text-right.mobile-center > a {
  display: inline-block;
  position: relative;
}
.col-md-5.col-sm-7.col-12.text-right.mobile-center > a > span {
  position: absolute;
  left: 50px;
  top: 12px;
  font-size: 18px;
  font-weight: 800;
  color: rgb(35, 36, 56);
}

.full-width-footer-bottom p {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.3);
}
.collapse-header {
  font-size: 30px;
  font-weight: bold;
}
.vuesax-app-is-ltr .vs-collapse-item--icon-header {
  right: 22%;
}
i.vs-icon {
  font-size: 35px;
}
.second-collapse .vuesax-app-is-ltr .vs-collapse-item--icon-header {
  left: 0;
}
.heading-footer {
  font-size: 18px;
  font-weight: bold;
  color: #fa7b35;
}
.vs-button-warning.vs-button-filled:hover {
  box-shadow: none;
}
.login-button {
  margin-top: 2px;
  box-shadow: none;
}
.includeIcon {
  float: right;
}
.con-content--item {
  padding: 20px;
}
.blank_layout {
  overflow-x: hidden;
}
.full-height {
  background-color: white;
}
@media screen and (min-width: 577px) {
  .full-height {
    background-color: white;
    display: grid;
    overflow-x: hidden;
    min-height: 100vh;
  }
}
@media screen and (max-width: 576px) {
  .row.mt-5 {
    margin-top: 0px !important;
    padding-top: 3rem;
  }
  .mobile-center {
    text-align: center !important;
  }
  .col-md-5.col-sm-7.col-12.text-right.mobile-center > a {
    display: none;
  }
  .login-button {
    margin: 18px auto 18px;
  }
  .includeIcon {
    float: initial;
  }
}

@media screen and (min-width: 1168px) {
  .full-width {
    margin-left: calc(-100vw / 2 + 1100px / 2);
    margin-right: calc(-100vw / 2 + 1100px / 2);
  }
  .full-width-footer {
    margin-left: calc(-100vw / 2 + 1140px / 2);
    margin-right: calc(-100vw / 2 + 1140px / 2);
  }
  .full-width-footer-bottom {
    // margin-left: calc(-100vw / 2 + 1140px / 2);
    // margin-right: calc(-100vw / 2 + 1140px / 2);
    border-top: 1px solid rgba(0, 0, 0, 0.04);
  }
}

@media screen and (max-width: 768px) {
  .row.full-width-footer.mt-5 > .col-md-3.col-12.text-right,
  .row.full-width-footer.mt-5 > .col-md-6.col-12.mb-5 {
    text-align: center !important;
  }
}

.swiper-container {
  background-color: #f0f5f9;
}
.swiper-slide {
  background-size: cover;
  background-position: center;
  height: 400px;
  &.slide-1 {
    background-image: url("../../assets/images/big/img1.jpg");
  }
  &.slide-2 {
    background-image: url("../../assets/images/big/img2.jpg");
  }
  &.slide-3 {
    background-image: url("../../assets/images/big/img3.jpg");
  }
  &.slide-4 {
    background-image: url("../../assets/images/big/img4.jpg");
  }
  &.slide-5 {
    background-image: url("../../assets/images/big/img5.jpg");
  }
}
</style>
